import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { RingostatService } from '../../../../../services/ringostat.service';
import { ChannelService } from '../../../../../services/channel.service';

interface IFormRingostat {
  api_key: FormControl;
  project_id: FormControl;
}

@Component({
  selector: 'app-integration-ringostat-channel',
  templateUrl: './integration-ringostat-channel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationRingostatChannelComponent implements OnInit {
  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  protected readonly webhookUrl = `${environment.baseURL}/v2/ringostat/webhook`;

  channel: any;
  form!: FormGroup<IFormRingostat>;
  isLoader: boolean = false;

  public statuses: any = {
    ACTIVE: { title: 'active_status', color: 'green', translate: true },
    EXPIRED: { title: 'expired_status', color: 'orange', translate: true },
    CLOSED: { title: 'closed_status', color: 'gray', translate: true },
    PAUSE: { title: 'pause_status', color: 'orange', translate: true },
  };

  constructor(
    private readonly ringostatService: RingostatService,
    private readonly channelService: ChannelService,
  ) {}

  ngOnInit() {
    this.isLoader = true;
    this.channelService.getChannelById(this.payload.channel_id || this.payload.channel.id).subscribe({
      next: (channel) => {
        this.channel = channel;
        this.onInitForm();
        this.isLoader = false;
      },
      error: () => {
        this.channel = this.payload.channel;
        this.onInitForm();
        this.isLoader = false;
      },
    });
  }

  onInitForm() {
    this.form = new FormGroup({
      api_key: new FormControl(this.channel.x_data?.api_key || null, Validators.required),
      project_id: new FormControl(this.channel.x_data?.project_id || null, Validators.required),
    });
  }

  save() {
    if (this.form.dirty && this.form.valid) {
      const { api_key, project_id } = this.form.getRawValue();

      this.ringostatService.connect({ api_key, project_id }, this.channel.id).subscribe(() => {
        this.cancel('success');
      });
    } else {
      this.cancel();
    }
  }

  cancel(event?: string) {
    this.close.emit(event);
  }
}
